import { AsyncPipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import {
  AaNgD3Module,
  ForceDirectedGraphNode,
  WordCloudOptions,
} from 'aa-ng-d3';
import { BehaviorSubject } from 'rxjs';

import { IResearchTerm } from '../../../models';

@Component({
  selector: 'app-key-terms',
  imports: [AaNgD3Module, AsyncPipe],
  templateUrl: './key-terms.component.html',
  styleUrls: ['./key-terms.component.scss'],
})
export class KeyTermsComponent implements OnInit {
  keyTerms$ = new BehaviorSubject<string[]>([]);
  termsForCloud: ForceDirectedGraphNode[];
  wordCloudOptions: WordCloudOptions = {
    chargeStrength: -150,
    circlesShouldCollide: true,
    circlesShouldDrag: false,
    disableInitialNodeBounce: false,
    fontSizeRange: {
      maxFontSize: 15,
      minFontSize: 8,
    },
    hasCenteredText: true,
    nodeRadiusRange: {
      maxNodeRadius: 42,
      minNodeRadius: 22,
    },
    shouldPanAndZoom: false,
    nodeTitleAttribute: true,
    svgTitle: 'Key Terms',
    svgDescription: 'Key Terms',
    padding: 0,
    enableKeyboardAccessibility: true,
  };
  _researchTermObjs: IResearchTerm[];
  @Input() useWordCloudKeyTerms: boolean;
  @Input() set researchTermObjs(val: IResearchTerm[]) {
    this.keyTerms$.next(val ? val.map((term) => term.term) : []);
    this._researchTermObjs = val;
  }

  ngOnInit() {
    if (this.useWordCloudKeyTerms) {
      this.termsForCloud = this.constructKeywords(this._researchTermObjs);
    }
  }

  private constructKeywords(
    results: IResearchTerm[],
  ): ForceDirectedGraphNode[] {
    let keywords = results.map((term) => ({
      name: term.term.length > 12 ? `${term.term.slice(0, 9)}...` : term.term,
      title: term.term,
      weight: term.score,
    }));

    // Post Processing
    keywords = keywords.filter((keyword) => keyword.weight > 0);
    keywords.forEach((keyword) => {
      keyword.weight = Math.log(keyword.weight);
    });

    return keywords;
  }
}
